export const DISCORD_DEVICE_SERIAL = 'discordDeviceSerial';
